import { Navigate, Outlet } from 'react-router-dom'

import { paths } from '@/app/router/paths'
import { useCanViewAnalytics } from '@/features/analytics/hooks/useCanViewAnalytics'

/**
 * A session without `ANALYTICS_READ` is sent to the pipeline: the server refuses it every
 * analytics request, so the page would be nothing but an error.
 */
export function AnalyticsRoute() {
  const canViewAnalytics = useCanViewAnalytics()

  if (!canViewAnalytics) return <Navigate to={paths.pipeline} replace />

  return <Outlet />
}
